/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const FileVideo2 = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M4 8V4a2 2 0 0 1 2-2h8.5L20 7.5V20a2 2 0 0 1-2 2H4" }],
    ["polyline", { points: "14 2 14 8 20 8" }],
    ["path", { d: "m10 15.5 4 2.5v-6l-4 2.5" }],
    ["rect", { width: "8", height: "6", x: "2", y: "12", rx: "1" }]
  ]
];

export { FileVideo2 as default };
//# sourceMappingURL=file-video-2.js.map
